import * as React from 'react';

let prefetched = false;

export const usePrefetchComment = () => {
  React.useEffect(() => {
    if (!prefetched) {
      // preload to avoid delay when opening comments
      import('@/features/Comment/components/Comments/Comments');

      prefetched = true;
    }
  }, []);
};
